import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

const Search = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 12 12'} {...props}>
    <svg>
      <path d="M7.38098 1.01398C5.63742 1.01398 4.22398 2.42741 4.22398 4.17098C4.22398 5.91454 5.63742 7.32798 7.38098 7.32798C9.12455 7.32798 10.538 5.91454 10.538 4.17098C10.538 2.42741 9.12455 1.01398 7.38098 1.01398ZM3.22398 4.17098C3.22398 1.87513 5.08514 0.0139771 7.38098 0.0139771C9.67683 0.0139771 11.538 1.87513 11.538 4.17098C11.538 6.46683 9.67683 8.32798 7.38098 8.32798C5.08514 8.32798 3.22398 6.46683 3.22398 4.17098Z" />
      <path d="M4.91559 6.33144C5.11085 6.52671 5.11085 6.84329 4.91559 7.03855L0.877586 11.0766C0.682324 11.2718 0.365741 11.2718 0.170479 11.0766C-0.024783 10.8813 -0.024783 10.5647 0.170479 10.3694L4.20848 6.33144C4.40374 6.13618 4.72032 6.13618 4.91559 6.33144Z" />
    </svg>
  </SvgIcon>
)
export default Search
